import { v4 as uuid } from 'uuid';

import { definitions } from '@luxuryescapes/contract-svc-promo';

type VoucherReward = definitions['VoucherRewardV1'];

export function copyVoucherReward(reward: VoucherReward, newId = uuid()): VoucherReward {
  return {
    ...reward,
    id_voucher_reward: newId,
    products: [...(reward.products ?? [])],
    min_spend_products: [...(reward.min_spend_products ?? [])],
  };
}
